import { render, staticRenderFns } from "./FormErrors.vue?vue&type=template&id=22bc4eea&"
import script from "./FormErrors.vue?vue&type=script&lang=js&"
export * from "./FormErrors.vue?vue&type=script&lang=js&"
import style0 from "./FormErrors.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports